import { atom } from "recoil";

export const deviceport = atom({
    key: "deviceport",
    default: undefined 
});